// extracted by mini-css-extract-plugin
export default {"box":"ResumeLaunchingMessage_box__A2s2r"};